import React, { useRef } from 'react';
import styles from '../styles/ImageCarousel.module.css';

const ImageCarousel = ({ title, items, ariaLabel, onSelect, showMeta, showPrice }) => {
  const trackRef = useRef(null);

  const move = direction => {
    if (!trackRef.current) return;

    trackRef.current.scrollBy({
      left: direction * trackRef.current.clientWidth,
      behavior: 'smooth',
    });
  };

  return (
    <section className={styles.section} aria-label={ariaLabel || title}>
      <div className={styles.inner}>
        {title && <h2 className={styles.title}>{title}</h2>}

        <div className={styles.viewport} ref={trackRef}>
          <div className={styles.track}>
            {items.map(item => (
              <button
                className={styles.card}
                key={item.id || item.title}
                type="button"
                onClick={() => onSelect(item)}
                aria-label={`Open details for ${item.title}`}
              >
                {item.backgroundSize && item.backgroundSize !== 'cover' ? (
                  <span
                    className={styles.image}
                    role="img"
                    aria-label={item.alt || item.title}
                    style={{
                      backgroundImage: `url('${item.src}')`,
                      backgroundPosition: item.backgroundPosition || 'center',
                      backgroundSize: item.backgroundSize,
                    }}
                  />
                ) : (
                  <span className={styles.image}>
                    <img
                      className={styles.imageAsset}
                      src={item.src}
                      alt={item.alt || item.title}
                      loading="eager"
                      decoding="async"
                    />
                  </span>
                )}
                {showMeta && (
                  <>
                    <span className={styles.cardTitle}>{item.title}</span>
                    {item.category && <span className={styles.category}>{item.category}</span>}
                    {showPrice && item.price && <span className={styles.price}>{item.price}</span>}
                  </>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className={styles.controls}>
          <button type="button" onClick={() => move(-1)} aria-label="Previous teas">
            <span aria-hidden="true">‹</span>
          </button>
          <button type="button" onClick={() => move(1)} aria-label="Next teas">
            <span aria-hidden="true">›</span>
          </button>
        </div>
      </div>
    </section>
  );
};

ImageCarousel.defaultProps = {
  title: '',
  items: [],
  ariaLabel: 'Image carousel',
  onSelect: () => {},
  showMeta: true,
  showPrice: true,
};

export default ImageCarousel;
